// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.odo-meter-header {
  font-size: 14px;
  font-weight: bold;
}

.status-light {
  width: 12px;
  height: 12px;
  display: inline-flex;
  background: blue;
  border-radius: 10px;
}

.meter-section {
  min-width: 210px;
}
.meter-section .odo-meter-section {
  text-align: right;
}
.meter-section .odo-meter-section ul {
  border-radius: 6px;
  padding: 7px 12px;
  margin-bottom: 5px;
}
.meter-section .type-toggle {
  cursor: pointer;
  margin: 0 5px;
}
.meter-section .device-input,
.meter-section .letter {
  min-width: 15px;
  text-align: center;
  padding: 0;
  margin: 0;
  line-height: 19px;
  font-size: 12px;
}
.meter-section .device-input {
  margin-left: 2px;
}
.meter-section .odo-meter-action {
  margin-left: 10px;
}
.meter-section time {
  font-size: 10px;
  float: right;
  font-weight: normal;
}
.meter-section .input-meter-section {
  text-align: right;
  white-space: nowrap;
}
.meter-section .input-meter-section ul {
  border-radius: 6px;
  padding: 5px 12px 4px;
  margin-bottom: 5px;
}
.meter-section .device-input {
  font-size: inherit;
  display: inline-block;
  border: 1px solid transparent;
  color: #333;
  font-weight: normal;
  min-width: 20px;
  min-height: 20px;
  line-height: 19px;
  border-radius: 50px;
}
.meter-section .device-input-alt {
  font-weight: bold;
}
.meter-section .list-unstyled .type-toggle {
  line-height: 19px;
  color: inherit;
  display: inline-block;
}
.meter-section .list-unstyled .type-toggle.active {
  font-weight: bold;
}
.meter-section .time-ago {
  display: inline-block;
  margin-top: 5px;
}

.event-section p {
  font-weight: 700;
  margin-bottom: 8px;
}

.map-filters-bar {
  border-radius: 8px;
  position: fixed;
  bottom: 32px;
  right: 8px;
  list-style: none;
  margin: 0;
  padding: 16px 5px;
  width: 37px;
  text-align: center;
}
.map-filters-bar li ~ li {
  margin-top: 16px;
}

.feature-content-section {
  padding: 5px 10px;
}

@media (max-width: 1499px) {
  .feature-row-head {
    padding: 6px 10px;
  }
}
@media (max-width: 767px) {
  .feature-row-1 {
    bottom: auto;
  }
}
#signal-strength {
  height: 20px;
  list-style: none;
  overflow: hidden;
}

#signal-strength li {
  width: 5px;
  float: left;
  height: 100%;
  margin-right: 1px;
}

#signal-strength li.sg-5 {
  padding-top: 1px;
}

#signal-strength li.sg-4 {
  padding-top: 5px;
}

#signal-strength li.sg-3 {
  padding-top: 8px;
}

#signal-strength li.sg-2 {
  padding-top: 12px;
}

#signal-strength li.sg-1 {
  padding-top: 15px;
}

#signal-strength li div {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Components/Features/FeatureSection/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,iBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;AADF;AAGE;EACE,iBAAA;AADJ;AAGI;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AADN;AAKE;EACE,eAAA;EACA,aAAA;AAHJ;AAME;;EAEE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,eCwCW;AD5Cf;AAcE;EACE,gBAAA;AAZJ;AAeE;EACE,iBAAA;AAbJ;AAgBE;EACE,eAAA;EAEA,YAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,iBAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AAhBN;AAoBE;EACE,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,WClDQ;EDmDR,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAlBJ;AAoBI;EACE,iBAAA;AAlBN;AAsBE;EAEE,iBAAA;EACA,cAAA;EACA,qBAAA;AArBJ;AAuBI;EACE,iBAAA;AArBN;AAyBE;EACE,qBAAA;EACA,eAAA;AAvBJ;;AA4BE;EACE,gBAAA;EACA,kBAAA;AAzBJ;;AA4BA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAzBF;AA0BE;EACE,gBAAA;AAxBJ;;AA4BA;EACE,iBAAA;AAzBF;;AA6BA;EACE;IACE,iBAAA;EA1BF;AACF;AA6BA;EACE;IACE,YAAA;EA3BF;AACF;AA8BA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AA5BF;;AA+BA;EAEE,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA7BF;;AAgCA;EACE,gBAAA;AA7BF;;AAgCA;EACE,gBAAA;AA7BF;;AAgCA;EACE,gBAAA;AA7BF;;AAgCA;EACE,iBAAA;AA7BF;;AAgCA;EACE,iBAAA;AA7BF;;AAgCA;EACE,YAAA;AA7BF","sourcesContent":["@import '../../../assets/variables';\n\n.odo-meter-header {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.status-light {\n  width: 12px;\n  height: 12px;\n  display: inline-flex;\n  background: blue;\n  border-radius: 10px;\n}\n\n.meter-section {\n  min-width: 210px;\n\n  .odo-meter-section {\n    text-align: right;\n\n    ul {\n      border-radius: 6px;\n      padding: 7px 12px;\n      margin-bottom: 5px;\n    }\n  }\n\n  .type-toggle {\n    cursor: pointer;\n    margin: 0 5px;\n  }\n\n  .device-input,\n  .letter {\n    min-width: 15px;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n    line-height: 19px;\n    font-size: $baseFontSize;\n\n    //color: #5f5f5f;\n    &-alt {\n      //color: #afafaf;\n      //background: #fff;\n      //border-color: $textColor;\n    }\n  }\n\n  .device-input {\n    margin-left: 2px;\n  }\n\n  .odo-meter-action {\n    margin-left: 10px;\n  }\n\n  time {\n    font-size: 10px;\n    //color: #888;\n    float: right;\n    font-weight: normal;\n  }\n\n  .input-meter-section {\n    text-align: right;\n    white-space: nowrap;\n\n    ul {\n      border-radius: 6px;\n      padding: 5px 12px 4px;\n      margin-bottom: 5px;\n    }\n  }\n\n  .device-input {\n    font-size: inherit;\n    display: inline-block;\n    border: 1px solid transparent;\n    color: $textColor;\n    font-weight: normal;\n    min-width: 20px;\n    min-height: 20px;\n    line-height: 19px;\n    border-radius: 50px;\n\n    &-alt {\n      font-weight: bold;\n    }\n  }\n\n  .list-unstyled .type-toggle {\n    //color: $darkGrey;\n    line-height: 19px;\n    color: inherit;\n    display: inline-block;\n\n    &.active {\n      font-weight: bold;\n    }\n  }\n\n  .time-ago {\n    display: inline-block;\n    margin-top: 5px;\n  }\n}\n\n.event-section {\n  p {\n    font-weight: 700;\n    margin-bottom: 8px;\n  }\n}\n.map-filters-bar {\n  border-radius: 8px;\n  position: fixed;\n  bottom: $footerHeight + 8px;\n  right: 8px;\n  list-style: none;\n  margin: 0;\n  padding: 16px 5px;\n  width: 37px;\n  text-align: center;\n  li ~ li {\n    margin-top: 16px;\n  }\n\n}\n.feature-content-section {\n  padding: 5px 10px;\n}\n\n// responsive\n@media (max-width: 1499px) {\n  .feature-row-head {\n    padding: 6px 10px;\n  }\n}\n\n@media (max-width: 767px) {\n  .feature-row-1 {\n    bottom: auto;\n  }\n}\n\n#signal-strength {\n  height: 20px;\n  list-style: none;\n  overflow: hidden;\n}\n\n#signal-strength li {\n  //display: inline-block;\n  width: 5px;\n  float: left;\n  height: 100%;\n  margin-right: 1px;\n}\n\n#signal-strength li.sg-5 {\n  padding-top: 1px;\n}\n\n#signal-strength li.sg-4 {\n  padding-top: 5px;\n}\n\n#signal-strength li.sg-3 {\n  padding-top: 8px;\n}\n\n#signal-strength li.sg-2 {\n  padding-top: 12px;\n}\n\n#signal-strength li.sg-1 {\n  padding-top: 15px;\n}\n\n#signal-strength li div {\n  height: 100%;\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
